var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pr-4 pl-3 py-3 space-y-3 cursor-pointer"},[(_vm.auth.user.role === 'teacher')?_c('CtaTeacher'):_vm._e(),_vm._v(" "),_vm._l((_vm.avatarList),function(item,i){return [_c(item.component,{key:i,tag:"component",attrs:{"tag-link":item.tagLink,"text":item.text,"icon":item.icon}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }